//  @flow
import React from 'react';
//  $Ignore
import { NavLink } from 'react-router-dom';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

type CarouselItemProps = {
  heading: string,
  image: string,
  text: string
};

const newItem = ({
  heading,
  image,
  text,
  webpImage,
  isExternalLink = false,
  linkText = '',
  linkPath = '',
  fallbackImage = ''
}: CarouselItemProps) => (
  <div className="home-landing-item">
    <div className="home-landing-left">
      <div className="content">
        <p className="landing-heading">{heading}</p>
        <p className="landing-desc">{text}</p>
        {isExternalLink ? (
          <a
            rel="noreferrer"
            className="link-first-slide"
            target="_blank"
            href={linkPath}>
            {linkText}
          </a>
        ) : (
          <NavLink className="link-first-slide" to={linkPath}>
            {linkText}
          </NavLink>
        )}
      </div>
    </div>

    <div className="home-landing-right">
      <ImageBlurFallback
        fallbackImage={fallbackImage}
        className="home-landing-right-img"
        webpImage={webpImage}
        src={image}
        alt="banner"
      />
    </div>
  </div>
);

export default newItem;



// WEBPACK FOOTER //
// ./src/Pages/Home/CarouselItem.js